import { CLASSROOM_MODULE_RESET } from '../actions';

export default () => (dispatch) => dispatch({ type: CLASSROOM_MODULE_RESET });
